export default function LockIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 11.9764V13.8514M8 11.9764C8.86294 11.9764 9.5625 11.2768 9.5625 10.4139C9.5625 9.55093 8.86294 8.85138 8 8.85138C7.13706 8.85138 6.4375 9.55093 6.4375 10.4139C6.4375 11.2768 7.13706 11.9764 8 11.9764ZM5.1875 6.35138V3.53888C5.1875 2.79296 5.48382 2.07759 6.01126 1.55014C6.53871 1.0227 7.25408 0.726379 8 0.726379C8.74592 0.726379 9.46129 1.0227 9.98874 1.55014C10.5162 2.07759 10.8125 2.79296 10.8125 3.53888V6.35138M1.75 6.35138H14.25C14.5952 6.35138 14.875 6.6312 14.875 6.97638V15.7264C14.875 16.0716 14.5952 16.3514 14.25 16.3514H1.75C1.40482 16.3514 1.125 16.0716 1.125 15.7264V6.97638C1.125 6.6312 1.40482 6.35138 1.75 6.35138Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
